export default __webpack_public_path__ + "static/media/chevron-left.21ff354a.svg";